

















import { Component, Vue, Prop } from 'vue-property-decorator';
import { IEpic, IProjectMin } from '@/lib/interfaces';

@Component
export default class EpicContent extends Vue {
  @Prop() private epic!: IEpic;
  @Prop() private project!: IProjectMin;
}
